export default __webpack_public_path__ + "static/konditerskaya-presentation-4d8b85108440013241edd86137d1a64f.png";